(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
  const observer = lozad();
  observer.observe();

  const videos = document.querySelectorAll('.grid-item video');
  let touchStartX, touchStartY, isDragging = false;
  
  function handleVideoClick(video, playButton) {
    const isPaused = video.paused;
  
    if (isPaused) {
      video.play();
      playButton.style.display = 'none';
    } else {
      video.pause();
      playButton.style.display = 'flex';
    }
  }

  
  videos.forEach(video => {
    const playButton = video.nextElementSibling;

    video.addEventListener('mouseenter', () => {
      if (!isDragging) {
        video.play();
        if (!video.paused) {
          playButton.style.display = 'none';
        }
      }
    });
  
    video.addEventListener('mouseleave', () => {
      if (!isDragging) {
        video.pause();
        playButton.style.display = 'flex';
      }
    });
  
    video.addEventListener('click', function () {
      if (!isDragging) {
        handleVideoClick(video, playButton);
      }
    });

    playButton.addEventListener('click', function () {
      handleVideoClick(video, playButton);
    });
    
    video.addEventListener('touchstart', function (event) {
      // Record the initial touch position
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      isDragging = false;
    });
  
    video.addEventListener('touchmove', function (event) {
      // Calculate the horizontal and vertical distances moved during the touch move
      const deltaX = Math.abs(event.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(event.touches[0].clientY - touchStartY);
  
      // If the vertical distance moved is greater than the horizontal distance, set isDragging to true
      if (deltaY > deltaX) {
        isDragging = true;
      } else {
        isDragging = false;
      }
    });

    video.addEventListener('touchend', function (event) {
      event.preventDefault(); // Prevent the click event after touchend
  
      if (!isDragging) {
        // It's a tap, so handle your video interaction
        handleVideoClick(video, playButton);
      }
  
      // Reset isDragging after touchend
      isDragging = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
